import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

const DigitalClock = ({ timeZone, locale }) => {
  const [time, setTime] = useState('');

  useEffect(() => {
    // Function to update time
    const updateTime = () => {
      const currentTime = new Date();

      // Format the time based on the specified time zone
      const timeFormatter = new Intl.DateTimeFormat(locale, {
        hour: '2-digit',
        minute: '2-digit',
        // second: '2-digit',
        timeZone: timeZone,
        // hour12: false,
      });

      const formattedTime = timeFormatter.format(currentTime);
      setTime(formattedTime);
    };

    // Update time every second
    const interval = setInterval(updateTime, 1000);

    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, [timeZone, locale]);

  return (
    <Box>
      <Typography
        variant="h3"
        noWrap
        sx={{
          color: 'black',
          lineHeight: 1,
          fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
        }}
      >
        {time}
      </Typography>
    </Box>
  );
};

export default DigitalClock;